import { FloatingBubble } from "antd-mobile";
import { MessageFill } from 'antd-mobile-icons'
import PhonelistPopup from "./PhonelistPopup";
import { useEffect, useState } from "react";
import styles from './style.scss'
import { CustomerServiceTmpl, IPhoneData } from "../../types/common";


interface Iprops {
    style?: Object;
    templateInfo: CustomerServiceTmpl | null;
    // fixed-固定位置，float-页面悬浮，
    // 这个不会取 templateInfo 里面的entryPosition，有部分场景是写死float
    type?: 'float' | 'fixed';
    // 隐藏条件
    hidden?: boolean;
    onClick?: () => void;
}

export function autoPhoneAction(templateInfo: CustomerServiceTmpl | null, cb: () => void) {
    if (!templateInfo) {
        return
    }
    // go to online url directly
    if (templateInfo?.serviceType === 'online') {
        if (templateInfo?.customerInfoDTO?.jumpUrl) {
            window.location.href =
                templateInfo?.customerInfoDTO?.jumpUrl
        }
        return
    }
    cb && cb()
}

export function ServicePhoneBubble(props: Iprops) {
    const { templateInfo, style = {}, type = 'float', hidden = false, onClick,...otherProps } = props
    const [bubbleZindex, setBubbleZindex] = useState(1001)
    const _style = {
        '--background': 'transparent',
        '--edge-distance': '15px',
        '--initial-position-bottom': (screen.height/5 || 22).toFixed(0) + 'px',
        '--initial-position-right': '15px',
        '--z-index': bubbleZindex,
        ...style,
    }
    const [visible, setVisible] = useState(false)
    const [phoneList, setPhoneList] = useState<IPhoneData[]>([])
    const [bubbleUrl, setBubbleUrl] = useState<string | null>(null)

    useEffect(() => {
        if (!templateInfo) return
        const { customerInfoDTO = {}, iconSetting, } = templateInfo || {}
        setBubbleUrl(iconSetting)
        if (customerInfoDTO && customerInfoDTO.servicePhoneContentObjs) {
            setPhoneList(customerInfoDTO.servicePhoneContentObjs || [])
        }

    }, [templateInfo])

    if (!templateInfo || hidden) return <></>

    return (
        <>
            {/* {!visible && <> */}
                {
                    type === 'float' ?
                        <FloatingBubble
                            axis='xy'
                            style={_style}
                            magnetic="x"
                            onClick={() => autoPhoneAction(templateInfo, () => {
                                setBubbleZindex(1000)
                                setVisible(true)
                                onClick && onClick()
                            })}
                            {...otherProps}
                        >
                            {bubbleUrl ? <img className={styles.bubbleInnerImg} src={bubbleUrl} alt="" /> : <MessageFill fontSize={32} />}
                        </FloatingBubble>
                        :
                        <img
                            onClick={() => autoPhoneAction(templateInfo, () => {
                                setBubbleZindex(1000)
                                setVisible(true)
                                onClick && onClick()
                            })}
                            className={styles.slidePhoneBtn}
                            src={templateInfo?.iconSetting}
                            alt={templateInfo?.entryDescription || "固定客服电话"}
                        />
                }
            {/* </>} */}
            {
                (templateInfo && templateInfo.serviceType !== 'online') && (
                    <PhonelistPopup
                        visible={visible}
                        title={templateInfo?.entryDescription || "联系客服"}
                        phoneList={phoneList}
                        onCancel={() => {
                            setBubbleZindex(1001)
                            setVisible(false)
                        }}
                    />
                )
            }
        </>
    )
}

export const ServicePhonePopup = PhonelistPopup

export default {
    Bubble: ServicePhoneBubble,
    Popup: ServicePhonePopup,
}